<template>
    <pendo-multiselect
        v-if="showFeatureFilter"
        :value="selectedFeatureType"
        :options="options"
        :allow-empty="false"
        @input="updateSelectedFeatureType" />
</template>
<script>
import { PendoMultiselect } from '@pendo/components';
import { mapMutations } from 'vuex';

export default {
    name: 'FeatureFilter',
    components: {
        PendoMultiselect,
    },
    inject: {
        showFeatureFilter: {
            default: false,
        },
        selectedFeatureType: {
            default: '',
        },
        options: {
            default: [],
        },
    },
    methods: {
        ...mapMutations('globalFilters', ['setSelectedFeatureType']),
        updateSelectedFeatureType (value) {
            this.setSelectedFeatureType({ featureType: value });
        },
    },
};
</script>
